module.exports = __webpack_public_path__ + "img/wangdongzhi.b49fd8b3.jpg";